import { BasvuruFlow, type ProductConfig } from "./BasvuruFlow";
import { InfoNote, PlateField, PLATE_RE, RuhsatField, TextField } from "./shared";

// WEB3 — Kasko teklif-talebi. Canonical [KAPI]: araç temel (plaka/ruhsat) + ehliyet
// alış tarihi + iletişim. Teminat tercihleri (İMM/ikame/cam/deprem), km ve park yeri
// [ADVISOR] — danışman sonra alır. Araç rayiç/hasar geçmişi [SBM].

const config: ProductConfig = {
  product: "kasko",
  intro: {
    eyebrow: "KASKO · TEKLİF TALEBİ",
    title: "Kasko teklifi",
    text: "Aracınız için tam kapsamlı koruma. Plaka, ruhsat ve ehliyet bilginizle başlayın; teminat tercihlerini danışmanınızla birlikte belirleyin.",
  },
  headerTitle: "Kasko",
  infoTitle: "Aracınızı tanıyalım",
  infoLead: "Plaka, ruhsat ve ehliyet bilgilerinizi girin.",
  renderInfo: (ctx) => (
    <>
      <PlateField
        value={ctx.fields.plaka ?? ""}
        onChange={ctx.setField("plaka")}
        error={ctx.errors.plaka}
      />
      <RuhsatField
        file={ctx.ruhsatFile}
        onFile={ctx.setRuhsatFile}
        escape={ctx.ruhsatEscape}
        onEscape={ctx.setRuhsatEscape}
        error={ctx.errors.ruhsat}
        status={ctx.ruhsatStatus}
        progress={ctx.ruhsatProgress}
        uploadError={ctx.ruhsatUploadError}
      />
      <TextField
        id="ehliyetTarihi"
        label="Ehliyet alış tarihi"
        type="date"
        value={ctx.fields.ehliyetTarihi ?? ""}
        onChange={ctx.setField("ehliyetTarihi")}
        error={ctx.errors.ehliyetTarihi}
      />
      <InfoNote>
        Teminat tercihleri (İMM, ikame araç, cam, deprem) ve aracın rayiç değeri danışmanınızla
        birlikte netleşir.
      </InfoNote>
    </>
  ),
  validateInfo: (ctx) => {
    const e: Record<string, string> = {};
    const plaka = (ctx.fields.plaka ?? "").trim().toUpperCase();
    if (!plaka) e.plaka = "Plaka zorunlu.";
    else if (!PLATE_RE.test(plaka)) e.plaka = "Geçerli bir TR plaka girin (örn. 34 ABC 123).";
    if (!ctx.ruhsatEscape && !ctx.ruhsatFile)
      e.ruhsat = "Ruhsat zorunlu. Yükleyin ya da telefonda ileteceğinizi işaretleyin.";
    if (!(ctx.fields.ehliyetTarihi ?? "").trim()) e.ehliyetTarihi = "Ehliyet alış tarihi zorunlu.";
    return e;
  },
  buildVehicle: (fields) => ({
    plate: (fields.plaka ?? "").trim().toUpperCase(),
    // Kasko §2 driver attr — ehliyet alış tarihi rides the vehicle block (YYYY-MM-DD).
    ehliyetDate: (fields.ehliyetTarihi ?? "").trim() || undefined,
  }),
  summary: (fields) => ({
    label: `Kasko · ${(fields.plaka ?? "").trim().toUpperCase() || "Aracınız"}`,
    value: "Teklif hazırlanıyor",
  }),
};

export function KaskoBasvuru() {
  return <BasvuruFlow config={config} />;
}
